<script lang="ts">
import HelpButton from "@/Components/Generics/HelpButton.vue";
import SelectableButton from "@/Components/Generics/SelectableButton.vue";
import { EconomicSectorId, EconomicSectors, SelectedEconomicSectorIds } from "@/Types";
import { PropType } from "vue";
import { defineComponent } from "vue";

export default defineComponent({
    components: {
        SelectableButton,
        HelpButton,
    },
    props: {
        sectors: {
            type: Array as PropType<EconomicSectors>,
            required: true,
        },
        selectedSectors: {
            type: Array as PropType<SelectedEconomicSectorIds>,
            required: true,
        },
    },
    emits: ["sectorValueChanged"],
    data: () => ({
        anythingClicked: false,
    }),
    computed: {
        sortedSectors(): EconomicSectors {
            const sectors = this.sectors;
            return sectors.sort((a, b) => this.$trans("company." + a.name).localeCompare(this.$trans("company." + b.name)));
        },
    },
    methods: {
        clickSelectAll(): void {
            this.anythingClicked = true;

            this.$emit(
                "sectorValueChanged",
                this.sortedSectors.map((s) => s.id)
            );
        },
        clickDeselectAll(): void {
            this.anythingClicked = true;

            this.$emit("sectorValueChanged", []);
        },
        clickSelectSector(id: EconomicSectorId): void {
            this.anythingClicked = true;

            let newSelectedSectors = this.selectedSectors;

            if (newSelectedSectors.includes(id)) {
                newSelectedSectors.splice(
                    newSelectedSectors.findIndex((sectorId) => sectorId === id),
                    1
                );
            } else {
                newSelectedSectors.push(id);
            }

            if (newSelectedSectors.length >= this.sortedSectors.length) {
                newSelectedSectors = [];
            }

            this.$emit("sectorValueChanged", newSelectedSectors);
        },
    },
});
</script>

<template>
    <div class="flex flex--width flex--v flex--valign-c flex--gap-20">
        <SelectableButton :title="$trans('company.all')" :selected="selectedSectors.length < 1" class="selectable-button" @click="clickDeselectAll()" />
        <div class="sectors-grid">
            <SelectableButton v-for="sector in sortedSectors" :key="sector.id" :title="$trans(`company.${sector.name}`)" :selected="selectedSectors.includes(sector.id)" class="selectable-button" @click="clickSelectSector(sector.id)">
                <template #absoluteContent>
                    <HelpButton :title="`company.${sector.name}`" />
                </template>
            </SelectableButton>
        </div>

        <!-- <GenericButton
            :title="selectedSectors.length !== sortedSectors.length ? $trans('company.select-all') : $trans('company.deselect-all')"
            @click="selectedSectors.length !== sortedSectors.length ? clickSelectAll() : clickDeselectAll()" /> -->
    </div>
</template>

<style lang="scss" scoped>
.sectors-grid {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(4, 1fr);
    gap: rem(20);

    .selectable-button {
        width: 100%;
    }
}

@include media-breakpoint-down(lg) {
    .sectors-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: rem(15);
    }
}
@include media-breakpoint-down(md) {
    .sectors-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: rem(10);
    }
}
@include media-breakpoint-down(sm) {
    .sectors-grid {
        grid-template-columns: repeat(1, 1fr);
        gap: rem(5);

        .selectable-button {
            width: calc(100% - #{rem(20)});
        }
    }
}
</style>
